const regex = /^(https:\/\/(studio\.)?moises\.ai(\/[^\s]*)?)|(^\/[^\s]*)$/

export const isInternalLink = (url: string): boolean => {
  return regex.test(url)
} 
